module.exports = __webpack_public_path__ + "img/p1.b42c753c.svg";